import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Row, Col, Form, ProgressBar } from "react-bootstrap";
import { forEach, isEmpty, find } from "lodash";
import validate from "validate.js";
import DatePicker from "react-datepicker";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CK_CONFIGS } from "configs/ckEditor";
import TimezoneSelect from "react-timezone-select";
import {
  UploadedAttachment,
  AudioRecorder,
  UploadImagesModal,
  UploadFilesModal,
  Header,
} from "./component";
import {
  hideIncidentValidationError,
  updateIncidentInitiation,
  redirectToIncidentList,
} from "actions";

const schema = {
  incident_name: {
    presence: { allowEmpty: false, message: "^Incident Name is required" },
  },
  incident_datetime: {
    presence: {
      allowEmpty: false,
      message: "^Incident Date & Time is required",
    },
  },
};

const IncidentUpdate = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const incidentState = useSelector((state) => state.incidentState);
  const session = useSelector((state) => state.session);
  const [incidentDateTime, setIncidentDateTime] = useState(new Date());
  const [isRecording, setIsRecording] = useState(false);
  const [showRecorder, setShowRecorder] = useState(false); //default hidden
  const now = 60;
  const audioRef = useRef();
  const wrapperRef = useRef(null);
  //const wrapper = document.querySelector(".ck-editor-wrapper");
  //if (wrapper) wrapper.classList.remove("hide-editor-main");
  const [ImagesmodalShow, setImagesModalShow] = React.useState(false);
  const [FilesmodalShow, setFilesModalShow] = React.useState(false);
  const [attachments, setAttachments] = useState([]);
  const [prvAttachments, setPrvAttachments] = useState([]);
  const [audioFiles, setAudioFiles] = useState([]);
  const [audioTranscription, setAudioTranscription] = useState("");
  const [selectedTimezone, setSelectedTimezone] = useState("UTC");

  const [formState, setFormState] = useState({
    isValid: false,
    values: {
      object_viewed_id: session.current_page_permissions?.object_id || "",
      incident_datetime: incidentDateTime,
    },
    touched: {
      object_viewed_id: true,
    },
    errors: {},
  });

  // Validate form on value change
  useEffect(() => {
    const errors = validate(formState.values, schema);
    setFormState((formState) => ({
      ...formState,
      isValid: !errors,
      errors: errors || {},
    }));
  }, [formState.values]);

  useEffect(() => {
    if (!isEmpty(incidentState.validation_error)) {
      const errors = incidentState.validation_error;
      setFormState((formState) => ({
        ...formState,
        isValid: errors ? false : true,
        errors: errors || {},
      }));
    }
  }, [incidentState.validation_error]);

  // Check if the update form needs to be shown
  useEffect(() => {
    if (incidentState.redirect_to_list) {
      navigate("/incidentInitiation");
    }
  }, [incidentState.redirect_to_list]);

  useEffect(() => {
    if (!incidentState.showViewPage && !incidentState.showUpdateForm) {
      navigate("/incidentInitiation");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [incidentState.showViewPage, incidentState.showUpdateForm]);

  useEffect(() => {
    let record = incidentState.incidentRecord;

    console.log("record", record);

    const parsedDate = record.incident_datetime
      ? new Date(record.incident_datetime + "Z")
      : new Date();

    setIncidentDateTime(parsedDate);

    setFormState((formState) => ({
      ...formState,
      values: {
        ...formState.values,
        incident_name: record.incident_name,
        incident_datetime: parsedDate,
        incident_timezone: record.incident_timezone,
        initiation_description:
          record.initiation_description &&
          record.initiation_description !== "null"
            ? record.initiation_description
            : "",
        id: record.id,
      },
      touched: {
        ...formState.touched,
        incident_name: true,
        incident_datetime: true,
        incident_timezone: true,
        initiation_description: true,
        id: true,
      },
    }));

    if (!isEmpty(record.attachments)) {
      setPrvAttachments(record.attachments);
    }
  }, [incidentState.incidentRecord]);

  useEffect(() => {
    if (!isEmpty(audioTranscription)) {
      let trans =
        (formState.values.initiation_description || "") + audioTranscription;

      setDescription(trans);
    }
  }, [audioTranscription]);

  useEffect(() => {
    if (showRecorder && audioRef.current) {
      audioRef.current.startRecording();
    }
  }, [showRecorder]);

  const handleChange = (event) => {
    event.persist();
    setFormState((prev) => ({
      ...prev,
      values: {
        ...prev.values,
        [event.target.name]: event.target.value,
      },
      touched: {
        ...prev.touched,
        [event.target.name]: true,
      },
    }));
    dispatch(hideIncidentValidationError(event.target.name));
  };

  const setDescription = (initiation_description) => {
    setFormState((formState) => ({
      ...formState,
      values: {
        ...formState.values,
        initiation_description: initiation_description,
      },
      touched: {
        ...formState.touched,
        initiation_description: true,
      },
    }));
    dispatch(hideIncidentValidationError("initiation_description"));
  };

  const handleIncidentDateTimeChange = (date) => {
    setIncidentDateTime(date);
    setFormState((prev) => ({
      ...prev,
      values: {
        ...prev.values,
        incident_datetime: date,
      },
      touched: {
        ...prev.touched,
        incident_datetime: true,
      },
    }));
  };

  const handleTimezoneChange = (timezone) => {
    const timezoneValue = typeof timezone === "string" ? timezone : timezone.value;
    setFormState((prev) => ({
      ...prev,
      values: {
        ...prev.values,
        incident_timezone: timezoneValue,
      },
      touched: {
        ...prev.touched,
        incident_timezone: true,
      },
    }));
  };

  const handleAudioFileChange = (file) => {
    setAudioFiles((prev) => [...prev, file]);
  };

  const handleMicClick = () => {
    setIsRecording(true);
    setShowRecorder(true);
    /*if (audioRef.current) {
      alert('sss');
      audioRef.current.startRecording();
    }*/
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      let data = new FormData();

      const formattedImplementationTime = formState.values.incident_datetime
        ? new Date(formState.values.incident_datetime)
            .toISOString()
            .slice(0, 19)
        : null;

      // Append values to FormData
      forEach(formState.values, (value, key) => {
        if (key === "incident_datetime") {
          data.append(key, formattedImplementationTime);
        } else {
          data.append(key, value);
        }
      });
      const object_viewed_id =
        session?.current_page_permissions?.object_id || "";
      data.append("object_viewed_id", object_viewed_id);

      // Append attachments
      if (!isEmpty(attachments)) {
        forEach(attachments, function (value) {
          console.log(value instanceof File);
          data.append("attachments[]", value);
        });
      }

      // Append audio files
      if (!isEmpty(audioFiles)) {
        forEach(audioFiles, function (value) {
          data.append("audio_files[]", value);
        });
      }
      // Append previous attachments
      if (!isEmpty(prvAttachments)) {
        forEach(prvAttachments, function (value) {
          console.log(value instanceof File);
          data.append("prvAttachments[]", value.id);
        });
      }

      await dispatch(updateIncidentInitiation(data, data.get("id")));
    } catch (error) {
      //console.error("Failed to save initiation:", error);
    }
  };

  const hasError = (field) =>
    formState.touched[field] && formState.errors[field] ? true : false;
  const hasBackendError = (field) => (formState.errors[field] ? true : false);

  return (
    <>
      <Header />
      <div className="p-4">
        <div className="main-content-div">
          <Row>
            <Col lg={4}>
              <Form.Group className="mb-3">
                <Form.Label className="label-input">Incident Name</Form.Label>
                <Form.Control
                  type="text"
                  name="incident_name"
                  placeholder="Incident name"
                  className="input-field"
                  value={formState.values.incident_name || ""}
                  onChange={handleChange}
                  isInvalid={hasError("incident_name")}
                />
                <Form.Control.Feedback type="invalid">
                  {hasError("incident_name") &&
                    formState.errors.incident_name[0]}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col lg={4}>
              <Form.Group className="mb-3">
                <Form.Label className="label-input">
                  Incident Date & Time
                </Form.Label>{" "}
                <div>
                  <DatePicker
                    selected={incidentDateTime}
                    onChange={handleIncidentDateTimeChange}
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={1}
                    dateFormat="yyyy-MM-dd HH:mm"
                    timeCaption="Time"
                    className={`form-control input-field w-100 ${
                      hasError("incident_datetime") ? "is-invalid" : ""
                    }`}
                    placeholderText="Select Date & Time"
                  />
                </div>
              </Form.Group>
            </Col>
            <Col lg={4}>
              <Form.Group className="mb-3">
                <Form.Label className="label-input">Timezone</Form.Label>
                <TimezoneSelect
                  value={formState.values.incident_timezone || ""}
                  onChange={handleTimezoneChange}
                  className={`w-100 multi-select ${
                    hasBackendError("incident_timezone") ? "is-invalid" : ""
                  }`}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <div className="mt-3 position-relative">
                <div
                  className={`ck-editor-wrapper ${
                    isRecording ? "hide-editor-main" : ""
                  }`}
                >
                  <CKEditor
                    editor={ClassicEditor}
                    config={CK_CONFIGS(localStorage.getItem("token"))}
                    data={formState.values.initiation_description || ""}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setDescription(data);
                    }}
                  />
                  {hasError("initiation_description") && (
                    <Form.Text className="text-danger">
                      {formState.errors.initiation_description[0]}
                    </Form.Text>
                  )}
                </div>
                {showRecorder && (
                  <AudioRecorder
                    ref={audioRef}
                    setIsRecording={setIsRecording}
                    setShowRecorder={setShowRecorder}
                    containerRef={wrapperRef}
                    setAudioTranscription={setAudioTranscription}
                    setAudioFile={handleAudioFileChange}
                  />
                )}
                <div className="btn-in-editor">
                  <button
                    className="bg-transparent border-0"
                    onClick={handleMicClick}
                  >
                    <img src="/assets/images/mic-icon.svg" />
                  </button>
                  <button
                    className="bg-transparent border-0"
                    onClick={() => setImagesModalShow(true)}
                  >
                    <img src="/assets/images/file-upload-icon.svg" />
                  </button>
                  <button
                    className="bg-transparent border-0"
                    onClick={() => setFilesModalShow(true)}
                  >
                    <img
                      src="/assets/images/attachment-icon.svg"
                      alt="Attachment"
                    />
                  </button>
                </div>
              </div>

              {!isEmpty(attachments) || !isEmpty(prvAttachments) ? (
                <>
                  <div className="connector"></div>
                  <div className="main-content-div mb-4">
                    <UploadedAttachment
                      attachments={attachments}
                      setAttachments={setAttachments}
                      prvAttachments={prvAttachments}
                      setPrvAttachments={setPrvAttachments}
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="mb-4"></div>
                </>
              )}
              {hasBackendError("attachments") && (
                <div className="text-danger mb-2">
                  {formState.errors.attachments[0]}
                </div>
              )}
            </Col>
          </Row>

          <div className="d-flex justify-content-start gap-3">
            <button
              onClick={(e) => dispatch(redirectToIncidentList())}
              className="c-b-btn"
            >
              Back To List
            </button>
            <button
              className="n-u-btn"
              onClick={(e) => handleSubmit(e)}
              disabled={!formState.isValid}
            >
              Update
            </button>
          </div>

          {/* Style to hide only .ck-editor__main during recording */}
          <style>
            {`
              .hide-editor-main .ck.ck-editor__main {
                display: none !important;
              }
            `}
          </style>
          <UploadImagesModal
            setAttachments={setAttachments}
            show={ImagesmodalShow}
            onHide={() => setImagesModalShow(false)}
          />
          <UploadFilesModal
            setAttachments={setAttachments}
            show={FilesmodalShow}
            onHide={() => setFilesModalShow(false)}
          />
        </div>
      </div>
    </>
  );
};

export default IncidentUpdate;
